 
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ScheduledMaintenanceState } from '../../actions/types/schedule-maintenance/GetScheduledMaintenanceTypes';

/**
 * Initial Dashboard state in store
 */
export const initialState: ScheduledMaintenanceState = {
  isLoading: false,
  isTrackerLoading: true,
  iseventDetailsLoading: true,
  success: false,
  errorMessage: '',
  ScheduledMaintenanceDetails: []
};

/**
 * get metric summary Slice to get metric
 */
export const getScheduledMaintenanceSlice = createSlice({
  name: 'getMetricsSummary',
  initialState,
  reducers: {
    getScheduledMaintenanceStarted: (state) => {
      state.isLoading = true;
    },

    getScheduledMaintenanceSuccess: (state, action: PayloadAction<any>) => {
      state.isLoading = false;
      state.success = true;
      state.errorMessage = '';
      state.ScheduledMaintenanceDetails = action.payload;
    },

    getScheduledMaintenanceFail: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.success = false;
      state.errorMessage = action.payload;
      state.ScheduledMaintenanceDetails =
        initialState.ScheduledMaintenanceDetails;
    },

    clearScheduledMaintenance: (state) => {
      state.isLoading = false;
      state.success = false;
      state.errorMessage = '';
      state.ScheduledMaintenanceDetails =
        initialState.ScheduledMaintenanceDetails;
    }
  }
});

export const {
  getScheduledMaintenanceStarted,
  getScheduledMaintenanceSuccess,
  getScheduledMaintenanceFail,
  clearScheduledMaintenance
} = getScheduledMaintenanceSlice.actions;
export default getScheduledMaintenanceSlice.reducer;
